/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Indicates, that the UI flow could be continued by showing a recovery ui
 */
export interface ContinueWithRedirectBrowserTo { 
    /**
     * Action will always be `redirect_browser_to` redirect_browser_to ContinueWithActionRedirectBrowserToString
     */
    action: ContinueWithRedirectBrowserTo.ActionEnum;
    /**
     * The URL to redirect the browser to
     */
    redirect_browser_to: string;
}
export namespace ContinueWithRedirectBrowserTo {
    export type ActionEnum = 'redirect_browser_to';
    export const ActionEnum = {
        RedirectBrowserTo: 'redirect_browser_to' as ActionEnum
    };
}


